import { Card, CardContent } from '@repo/shadcn';

import { DataTable } from '@/components/ui/data.table/data-table';
import HeadingWrapper from '@/components/ui/heading/heading-wrapper';
import PageHeading from '@/components/ui/heading/page-headeing';
import PaginationComponent from '@/components/ui/pagination';
import { DEFAULT_PAGE_LIMIT } from '@/constants';

import { columns } from './wholesale-order-customers.column';
import { useWholesaleAdminOrderCustomers } from './wholesale-order-customers.hook';

export const WholesaleOrderCustomers = () => {
    const { data, isLoading, error, currentPage, setCurrentPage } =
        useWholesaleAdminOrderCustomers();

    const renderContent = () => {
        if (isLoading) {
            return 'Loading...';
        }
        if (error) {
            return 'Error';
        }
        if (!isLoading && data) {
            return (
                <>
                    <DataTable columns={columns} data={data.data} />

                    <p className="mt-3 flex w-full items-center px-4 text-right text-[20px] font-semibold">
                        Total Found : {data?.pagination?.total_items}
                    </p>
                    <PaginationComponent
                        totalItems={data?.pagination?.total_items || 0}
                        itemsPerPage={
                            data?.pagination?.limit || DEFAULT_PAGE_LIMIT
                        }
                        initialPage={currentPage}
                        onPageChange={(p) => {
                            setCurrentPage(p);
                        }}
                    />
                </>
            );
        }
    };

    return (
        <>
            <HeadingWrapper>
                <div className="flex items-center justify-between py-4">
                    <PageHeading title="Wholesale Customers" subTitle="" />
                </div>
                <Card>
                    <CardContent className="p-4">{renderContent()}</CardContent>
                </Card>
            </HeadingWrapper>
        </>
    );
};
